import { getPropertyState } from '../properties.selectors'
import { ActivatedRoute } from '@angular/router'
import { Component, OnInit, OnDestroy } from '@angular/core'
import { Subscription } from 'rxjs'
import FormTrait from 'src/app/traits/form.trait'
import { Store, select } from '@ngrx/store'
import { FormBuilder, FormGroup } from '@angular/forms'
import { FetchPropertyHistoryRequest, UpdateField } from '../properties.actions'
import { filtersToDbQuery } from '@shared/shared.utils'
import { TableFilterType } from '@shared/shared.types'
import { getAuditLogInfoState } from '@containers/audit-logs/audit-logs.selectors'
import { fromJS, Map } from 'immutable'
import { FetchAuditLogInfoRequest } from '@containers/audit-logs/audit-logs.actions'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'app-property-history',
  templateUrl: './property-history.component.html',
  styleUrls: ['./property-history.component.css'],
})
export class PropertyHistoryComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  public propertyId: number
  public logs: any[]
  private state$: Subscription
  public isLoading: boolean
  form: FormGroup
  public isInfoLoading: boolean
  public isInfoModalOpen: boolean
  private info$: Subscription
  public info: Map<string, any> = fromJS({})
  public filters: any[] = []
  public columns: object[] = [
    {
      prop: 'actor',
      name: 'ACTOR',
      sortable: true,
      render: (column: Map<string, any>) => {
        return `${column.get('firstName')} ${column.get('lastName')}`
      },
    },
    {
      prop: 'note',
      name: 'NOTE',
      sortable: true,
    },
    {
      prop: 'createdAt',
      name: 'CREATED_AT',
      sortable: true,
      template: 'createdAtColumn',
    },
    {
      prop: 'info',
      name: '',
      sortable: false,
      template: 'infoColumn',
    },
  ]

  constructor(
    public store: Store<any>,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    public translateService: TranslateService,
  ) {
    super()
  }

  ngOnInit() {
    this.propertyId = parseInt(this.route.parent.snapshot.params.id, 10)

    this.state$ = this.store
      .pipe(select(getPropertyState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.getIn(['history', 'isLoading'])
        this.logs = state.getIn(['history', 'data']).toJS()
      })

    this.info$ = this.store
      .pipe(select(getAuditLogInfoState))
      .subscribe((state) => {
        this.info = state.get('data')
        this.isInfoLoading = state.get('isLoading')
      })

    this.runFilter()
  }

  getPagination(key: string) {
    return this.state.getIn(['history', 'pagination', key])
  }

  toggleInfoModal(id?: number) {
    if (!this.isInfoModalOpen && id) {
      this.store.dispatch<any>(new FetchAuditLogInfoRequest(id))
    }

    this.isInfoModalOpen = !this.isInfoModalOpen
  }

  onPageChange(page: number) {
    this.runFilter({
      pagination: {
        ...(this.state.getIn(['history', 'pagination']) as any).toJS(),
        page,
      },
    })
  }

  onPageSizeChange(page_size: number) {
    this.runFilter({
      pagination: {
        page: 1,
        page_size,
      },
    })
  }

  onSort(prop: string) {
    const pagination = (
      this.state.getIn(['history', 'pagination']) as any
    ).toJS()
    let order_by: string = prop
    let sort: string

    if (pagination.sort) {
      if (pagination.sort === 'desc') {
        sort = 'asc'
      } else if (pagination.sort === 'asc') {
        sort = undefined
        order_by = undefined
      }
    } else {
      sort = 'desc'
    }

    this.runFilter({
      filters: {},
      pagination: {
        ...(this.state.getIn(['history', 'pagination']) as any).toJS(),
        sort,
        order_by: prop,
      },
    })
  }

  runFilter(data?: any) {
    const filters = data?.filters ?? this.filters
    const pagination =
      data?.pagination ??
      (this.state.getIn(['history', 'pagination']) as any).toJS()

    const { page, page_size, sort, order_by } = pagination

    this.store.dispatch<any>(
      new FetchPropertyHistoryRequest(this.propertyId, {
        filters: {},
        pageSize: parseInt(page_size, 10),
        page: parseInt(page, 10) - 1,
        sort: {
          order: sort?.toUpperCase(),
          prop: order_by,
        },
      }),
    )

    this.store.dispatch(new UpdateField('filters', filters, 'property.history'))
    this.store.dispatch(
      new UpdateField('pagination', pagination, 'property.history'),
    )
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
  }
}
